<script setup>
/******************************************************************************
 * Component: Loading Spinner
 * color of the spinner is determined by the "color" prop of the parent.
 *****************************************************************************/
defineProps({
    size: {
        type: String,
        default: "24px",
    },
});
</script>

<template>
    <aside class="loader" />
</template>

<style lang="scss" scoped>
.loader {
    display: grid;

    width: v-bind(size); /* control the size */
    aspect-ratio: 1;

    /* stylelint-disable property-no-vendor-prefix */
    -webkit-mask: conic-gradient(from 15deg, #0003, #000);
    /* stylelint-enable property-no-vendor-prefix */
    mask: conic-gradient(from 15deg, #0003, #000);

    animation: load 1s steps(12) infinite;
}

.loader,
.loader::before,
.loader::after {
    /* stylelint-disable indentation */
    background:
        radial-gradient(circle closest-side, currentColor 90%, #0000 98%)
            50% -150%/20% 80% repeat-y,
        radial-gradient(circle closest-side, currentColor 90%, #0000 98%) -150%
            50%/80% 20% repeat-x;
    /* stylelint-enable indentation */
}

.loader::before,
.loader::after {
    grid-area: 1/1;

    transform: rotate(30deg);

    content: "";
}

.loader::after {
    transform: rotate(60deg);
}

@keyframes load {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}
</style>
